module.exports = __webpack_public_path__ + "static/media/cancel.fab25bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/Cancel/cancel.png
// module id = 171
// module chunks = 0